import { useEffect, useState } from "react";
import {
  libraryShiftAdd,
  libraryShiftDelete,
  libraryShiftsList,
  libraryShiftStatusChange,
  libraryShiftUpdate,
} from "../../api/Library";
import { closeModal, LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import usePrivateLink from "../config/usePrivateLink";
import Swal from "sweetalert2";
import { formatToTime } from "../master/FormatToDateTime";
import LibraryLayout from "./LibraryLayout";

export default function LibraryShifts() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [modalData, setModalData] = useState({});

  const getShiftsList = async () => {
    setLoading(true);
    try {
      const response = await libraryShiftsList();
      if (response.data?.status) {
        setShifts(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getShiftsList();
  }, []);

  const createShift = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await libraryShiftAdd(formData);
      if (response?.data?.status) {
        closeModal("addNewShift");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getShiftsList();
    }
  };

  const updateShift = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      const response = await libraryShiftUpdate(formData);
      if (response?.data?.status) {
        closeModal("editShift");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getShiftsList();
    }
  };
  const updateShiftStatus = async (id) => {
    setLoading(true);
    try {
      const response = await libraryShiftStatusChange(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getShiftsList();
    }
  };

  const deleteShift = async (id) => {
    setLoading(true);
    try {
      const response = await libraryShiftDelete(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getShiftsList();
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <LibraryLayout />
                  <div className="col-12">
                    <div className="card my-3">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                          <h4 className="text-primary mb-0">Library Shift</h4>
                          <div className="d-flex gap-2">
                            {hasAccess("/library/shift/add") && (
                              <button
                                className="btn btn-label-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#addNewShift"
                              >
                                + Add Library Shift
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr className="text-nowrap">
                                <th>#</th>
                                <th>Shift</th>
                                <th>Timing</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {shifts?.map((item, i) => (
                                <tr key={item?.id}>
                                  <td>{i + 1}</td>
                                  <td>{item?.name}</td>
                                  <td>
                                    {formatToTime(item?.start_time)} -{" "}
                                    {formatToTime(item?.end_time)}
                                  </td>
                                  <td>
                                    {hasAccess("/library/shift/status") && (
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input fs-5 "
                                          type="checkbox"
                                          role="switch"
                                          id="switchCheckDefault"
                                          checked={item?.status == "1" && true}
                                          onChange={() =>
                                            updateShiftStatus(item?.id)
                                          }
                                        />
                                      </div>
                                    )}
                                  </td>

                                  <td>
                                    {hasAccess("/library/shift/update") && (
                                      <button
                                        onClick={() => {
                                          setModalData(item);
                                        }}
                                        className="btn btn-label-info btn-sm me-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editShift"
                                      >
                                        <i className="bi bi-pencil-square"></i>{" "}
                                      </button>
                                    )}
                                    {hasAccess("/library/shift/delete") && (
                                      <button
                                        className="btn btn-label-danger btn-sm me-2"
                                        onClick={() =>
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "This action will permanently delete !",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#d33",
                                            cancelButtonColor: "#6c757d",
                                            confirmButtonText:
                                              "Yes, delete it!",
                                            cancelButtonText: "Cancel",
                                          }).then(async (result) => {
                                            if (result.isConfirmed) {
                                              deleteShift(item?.id);
                                            }
                                          })
                                        }
                                      >
                                        <i className="bi bi-trash-fill"></i>{" "}
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editShift"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={updateShift}>
              <div className="modal-header bg-label-primary p-3">
                <h3 className="modal-title fs-5" id="exampleModalLabel">
                  Edit Library Shift
                </h3>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className=" p-3">
                  <input type="hidden" name="id" value={modalData?.id} />
                  <div className="mb-3">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control input-uppercase"
                        placeholder="Enter Name"
                        name="name"
                        defaultValue={modalData?.name}
                        required
                      />
                      <label className="">Name</label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        name="start_time"
                        defaultValue={modalData?.start_time}
                        required
                      />
                      <label className="">Start Time</label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        name="end_time"
                        defaultValue={modalData?.end_time}
                        required
                      />
                      <label className="">End Time</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addNewShift"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={createShift}>
              <div className="modal-header bg-label-primary py-3">
                <h1
                  className="modal-title fs-5"
                  id="exampleModalLabel bg-label-primary"
                >
                  Add Library Shift
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-uppercase"
                      placeholder="Enter Name"
                      name="name"
                      required
                    />
                    <label className="">Name</label>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="time"
                      className="form-control"
                      name="start_time"
                      required
                    />
                    <label className="">Start Time</label>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="time"
                      className="form-control"
                      name="end_time"
                      required
                    />
                    <label className="">End Time</label>
                  </div>
                </div>
              </div>
              <div className="modal-footer  bg-label-primary py-3">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
